<template>
<div>
    <ul class="list-group" v-if="dados.length > 0" >
        <slot></slot>    
    </ul>
</div>
  
</template>

<script>
export default {
    name: 'Buscar',
    props : {
        dados: [Array],

    },

    data() {
        return {

        }
    }
}
</script>

<style>

</style>